



















































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import pagelist from "@/components/pagelistcomponent";
import edit from "./ChannelSuppliersEdit.vue";
import AgentBalanceAdjustOrderEdit from "@/views/AgentManage/AgentBalanceAdjustOrder/AgentBalanceAdjustOrderEdit.vue";
import CreditQuotaAdjust from "@/views/ChannelManage/ChannelSupplierCreditQuotaOrder/ChannelSupplierCreditQuotaOrderEdit.vue";
import ChannelAdvanceMoneyAdjustOrderEdit from "@/views/ChannelManage/ChannelAdvanceMoneyAdjustOrder/ChannelAdvanceMoneyAdjustOrderEdit.vue";
@Component({
  components: {
    edit,
    AgentBalanceAdjustOrderEdit,
    CreditQuotaAdjust,
    ChannelAdvanceMoneyAdjustOrderEdit,
  },
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.ChannelSupplierServiceProxy();
  }
  options3 = {
    disabledDate(date) {
      return (
        date &&
        (date.valueOf() < Date.now() - 86400000 * 2 ||
          date.valueOf() > Date.now())
      );
    },
  };
  settlementreq = new proxy.ChannelSupplierSettlementDto();
  input: proxy.ChannelSupplierPageInputDto =
    new proxy.ChannelSupplierPageInputDto();
  sub_id = 0;
  qlShow = false;
  balanceShow = false;
  sendbills = true;
  googlecode = "";
  createOrEditShow = false;
  channelsupplierId = 0;
  CreditQuotaAdjustShow = false;
  AgentBalanceAdjustOrderEditshow = false;
  ChannelAdvanceMoneyAdjustOrderEditshow = false;
  channelId = 0;
  total = new proxy.ChannelTotalOutDto();
  dayType = 1;
  jiesuanloading = false;
  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
    },
    {
      title: "名称",
      key: "name",
    },

    {
      title: "余额",
      slot: "balance",
    },
    {
      title: "预付",
      slot: "advanceMoney",
      sortable: "custom",
    },
    {
      title: "信用额度",
      slot: "creditQuota",
    },
    {
      title: "实时余额",
      slot: "realBalance",
    },
    {
      title: "状态",
      slot: "isEnable",
      width: 100,
    },
    {
      title: "群ID",
      key: "groupId",
    },
    {
      title: "创建时间",
      key: "creationTime",
    },

    // {
    //   title: "操作",
    //   slot: "oper",
    // },
  ];
  sortchange(a) {
    if (a.order == "desc") {
      this.sorting = (a.column.slot || a.column.key) + " desc, id desc";
    }
    if (a.order == "asc") {
      this.sorting = (a.column.slot || a.column.key) + " asc, id desc";
    }
    if (a.order == "normal") {
      this.sorting = "IsEnable desc,id desc";
    }
    this.getpage();
  }
  adjadvanceMoney(row) {
    this.channelId = row.id;
    this.ChannelAdvanceMoneyAdjustOrderEditshow = true;
  }
  adjCreditQuota(item) {
    this.channelsupplierId = item.id;
    this.CreditQuotaAdjustShow = true;
  }

  advanceMoneyReset() {
    let req = new proxy.IdsDto();
    req.idList = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.prox.googleCodeVerify(this.googlecode, req).then((x) => {
      this.$Notice.success({ title: "操作成功" });
      this.getpage();
      this.googlecode = "";
      this.qlShow = false;
    });
  }

  qlGoogleCode() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    this.qlShow = true;
    this.googlecode = "";
  }

  balanceGoogleCode() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
 
    this.balanceShow = true;
  }

  supplierSettlement() {
    this.jiesuanloading = true;
    
    this.settlementreq.supplierIds = this.selectedDataItems.map((x) => x.id);
    // req.googleCode = this.googlecode;
    // req.sendbills = this.sendbills;
    // req.dayType = this.dayType;
    this.$Message.info("订单结算中,请耐心等待,不要重复点击");
    this.prox
      .channelSupplierSettlement(this.settlementreq)
      .then(() => {
        this.$Notice.success({ title: "供应商结算成功！" });
         this.balanceShow = false;
        this.getpage();
      })
      .finally(() => {
        this.jiesuanloading = false;
      });
  }

  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    if (!this.input.sorting) {
      this.input.sorting = "IsEnable desc,id desc";
    }
    this.prox.queryModelList(this.input).then((x) => {
      this.dataList = x.items;
      this.showPaging(x);
    });

    this.prox.queryModelListTotal(this.input).then((x) => {
      this.total = x;
    });
  }
  statuschange(row) {
    this.prox.createOrUpdate(row).then((x) => {
      this.$Notice.success({ title: "修改成功" });
      this.getpage();
    });
  }

  BatchStatusChange(e) {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    let req = new proxy.IdsDto();
    req.idList = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.prox.batchStatusChange(e, req).then((x) => {
      this.$Notice.success({ title: "修改成功" });
      this.getpage();
    });
  }

  getpage() {
    this.OnInit();
  }
  async created() {
    this.getpage();
  }
  create() {
    this.createOrEditShow = true;
    this.sub_id = undefined;
  }
  edit(row) {
    if (!row) {
      if (this.selectedDataItems.length == 0) {
        this.$Notice.error({ title: "请选中一条数据" });
        return;
      }
      row = this.selectedDataItems[0];
    }
    this.sub_id = row.id;
    this.createOrEditShow = true;
  }

  del() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中一条数据" });
      return;
    }

    this.$Modal.confirm({
      title: "你确定要删除吗?删除后将无法恢复",
      onOk: () => {
        this.prox
          .deletes(
            this.selectedDataItems.map((x) => {
              return x.id;
            })
          )
          .then(() => {
            this.$Notice.success({ title: "删除成功" });
            this.getpage();
          });
      },
    });
  }
}
